import React, { useState, useEffect } from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faHashtag } from '@fortawesome/free-solid-svg-icons';

import './ResetPassword.css';
import { sendAsyncRequest } from '../../services/AsyncRequestService';

import logo from "../../assets/images/RM Logo=Reversed.png";

import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

const ResetPassword = () => {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    }
  }, [location.state]);

  const handleChange = e => {
    const { name, value } = e.target;
    setError("");
    if (name === 'code') {
        setCode(value);
    } else if (name === 'password') {
        setPassword(value);
    } else if (name === 'confirmPassword') {
        setConfirmPassword(value);
    }
  }

  const handleResetPassword = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    sendAsyncRequest('/auth/reset-password', "POST", { email: email, code: code, newPassword: password, confirmPassword: confirmPassword }, onResetPasswordSuccess, onResetPasswordFailure);
  }

  const onResetPasswordSuccess = (response) => {
    setSuccess("Your password has been reset successfully. Redirecting to login...");
    setTimeout(() => {
        setRedirect(true);
    }, 2000);
  }

  const onResetPasswordFailure = (error) => {
    setError("An error occurred. Please try again.");
  }

  if (redirect) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="reset-password-container">
      <div className="login-page">
              <Card className="login-card">
                <Card.Body>
                  <div className="logo-large">
                    <img src={logo} alt="Imagine RazorMetrics Logo" style={{ maxWidth: '200px' }} />
                  </div>
                  <h3 className="login-title">Reset Password</h3>
                  {error && <Alert variant="danger">{error}</Alert>}
                  {success && <Alert variant="success">{success}</Alert>}
                  <Form onSubmit={handleResetPassword}>
                    <Form.Group className="form-group">
                      <div className="input-group">
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faEnvelope} />
                        </span>
                        <Form.Control
                          type="email"
                          name="email"
                          value={email}
                          readOnly
                          className="form-control-with-icon"
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <div className="input-group">
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faHashtag} />
                        </span>
                        <Form.Control
                          type="text"
                          name="code"
                          value={code}
                          placeholder="Enter the code from your email"
                          onChange={handleChange}
                          className="form-control-with-icon"
                          required
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <div className="input-group">
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faLock} />
                        </span>
                        <Form.Control
                          type="password"
                          name="password"
                          value={password}
                          placeholder="Enter your new password"
                          onChange={handleChange}
                          className="form-control-with-icon"
                          required
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <div className="input-group">
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faLock} />
                        </span>
                        <Form.Control
                          type="password"
                          name="confirmPassword"
                          value={confirmPassword}
                          placeholder="Confirm your new password"
                          onChange={handleChange}
                          className="form-control-with-icon"
                          required
                        />
                      </div>
                    </Form.Group>
                    <Button type="submit" variant="primary" className="login-button">
                      Submit
                    </Button>
                    <div className="text-center" style={{ marginTop: '20px' }}>
                      <Link to="/login">Back to Login</Link>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
      </div>
    </div>
  );
}

export default ResetPassword;
